import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { AdditionalServicesType, UFOPart } from 'types/UFOTypes';
import { CommonPricesParamsType } from 'utils/getPricesCallCommonParams';
import { BREAKPOINT } from 'utils/responsivenessUtils';
import { SelectedServicesType } from '../WizardContext';
import { WizardAdditionalServicesDesktop } from './WizardAdditionalServicesDesktop';
import { WizardAdditionalServicesMobile } from './WizardAdditionalServicesMobile';

export const WizardAdditionalServices = (props: {
  additionalServices: AdditionalServicesType[];
  searchedPart?: AdditionalServicesType | UFOPart;
  refs?;
  highlight?: boolean;
  category?: string;
  setSelectedServices: React.Dispatch<React.SetStateAction<SelectedServicesType[]>>;
  selectedServices: SelectedServicesType[];
  commonPricesParams: CommonPricesParamsType;
}) => {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down(BREAKPOINT));
  const {
    additionalServices,
    searchedPart,
    refs,
    highlight,
    category,
    selectedServices,
    setSelectedServices,
    commonPricesParams,
  } = props;

  return (
    <>
      {!mobileView && (
        <WizardAdditionalServicesDesktop
          additionalServices={additionalServices}
          searchedPart={searchedPart}
          refs={refs}
          highlight={highlight}
          category={category}
          selectedServices={selectedServices}
          setSelectedServices={setSelectedServices}
          commonPricesParams={commonPricesParams}
        />
      )}
      {mobileView && (
        <WizardAdditionalServicesMobile
          additionalServices={additionalServices}
          searchedPart={searchedPart}
          refs={refs}
          highlight={highlight}
          category={category}
          selectedServices={selectedServices}
          setSelectedServices={setSelectedServices}
          commonPricesParams={commonPricesParams}
        />
      )}
    </>
  );
};
